import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { AdminLogin } from './AdminLogin'
import { AdminLayout } from './AdminLayout'
import { AdminDashboard } from './AdminDashboard'
import { EmendaList } from './EmendaList'
import { EmendaFormProduction } from './EmendaFormProduction'
import { EmendaDetailProduction } from './EmendaDetailProduction'

export const AdminPanel: React.FC = () => {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <AdminLogin />
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/emendas" element={<EmendaList />} />
        <Route path="/emendas/nova" element={<EmendaFormProduction />} />
        <Route path="/emendas/:id" element={<EmendaDetailProduction />} />
        <Route path="/emendas/:id/editar" element={<EmendaFormProduction />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  )
}
